// noinspection JSUnusedGlobalSymbols
export default () => ({
    counts: {},
    entities: {},
})
